(() => {
  const page = document.querySelector('[data-d59-product-page]');
  const funnel = document.querySelector('[data-d59-pdp-funnel]');
  if (!page && !funnel) return;

  const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const publish = (name, data = {}) => {
    try { window.DOPAAnalytics?.publish?.(name, data); } catch (_) {}
    try { window.dataLayer?.push?.({ event:name, ...data }); } catch (_) {}
  };

  const normalizeOrderLabel = (value) => {
    const raw = String(value || '').trim();
    const replacements = new Map([
      ['PRE-ORDER DOPA DAY SYSTEM','ORDER DOPA DAY SYSTEM'],
      ['PRE-ORDER DAY SYSTEM','ORDER DAY SYSTEM'],
      ['PRE-ORDER DOPA SYSTEM','ORDER DOPA SYSTEM'],
      ['PRE-ORDER SYSTEM','ORDER SYSTEM'],
      ['PRE-ORDER IQ300 3 PACK','ORDER IQ300 3 PACK'],
      ['PRE-ORDER 3 PACK','ORDER 3 PACK'],
      ['PRE-ORDER DOPA MAX','ORDER DOPA MAX'],
      ['PRE-ORDER IQ300','ORDER IQ300'],
      ['PRE-ORDER KIK','ORDER KIK'],
      ['PRE-ORDER RESET','ORDER RESET'],
      ['PRE-ORDER FOCUS','ADD FOCUS'],
      ['PRE-ORDER ENERGY','ADD ENERGY'],
      ['PRE-ORDER REST','ADD REST'],
      ['PRE-ORDER FRESH','ADD FRESH'],
      ['PRE-ORDER NOW','ORDER NOW'],
      ['PRE-ORDER','ADD TO BAG']
    ]);
    const exact = replacements.get(raw.toUpperCase());
    if (exact) return exact;
    if (/^\+\s*PRE-ORDER\b/i.test(raw)) return raw.replace(/^\+\s*PRE-ORDER\b/i, '+ ADD');
    if (/^PRE-ORDER\b/i.test(raw)) return raw.replace(/^PRE-ORDER\b/i, 'ORDER');
    return raw;
  };

  const labelFor = (button) => {
    if (!button) return '';
    const unavailable = button.disabled || button.getAttribute('data-scroll-only') === 'true';
    if (unavailable) return button.dataset.dopaUnavailableLabel || 'VIEW OPTIONS';
    return normalizeOrderLabel(button.dataset.dopaReadyLabel || button.textContent || 'ADD TO BAG');
  };

  const syncLabels = (root = document) => {
    root.querySelectorAll?.('[data-dopa-ready-label]').forEach((button) => {
      if (button.dataset.dopaReadyLabel) button.dataset.dopaReadyLabel = normalizeOrderLabel(button.dataset.dopaReadyLabel);
      if (button.getAttribute('aria-busy') === 'true' || button.classList.contains('is-added')) return;
      const label = labelFor(button);
      if (label && button.textContent !== label) button.textContent = label;
    });
  };

  const updateProgress = () => {
    const bar = document.querySelector('[data-d59-progress-bar]');
    if (!bar) return;
    const root = document.documentElement;
    const max = Math.max(1, root.scrollHeight - window.innerHeight);
    const progress = Math.min(1, Math.max(0, window.scrollY / max));
    bar.style.width = `${(progress * 100).toFixed(2)}%`;
  };

  let progressTicking = false;
  const queueProgress = () => {
    if (progressTicking) return;
    progressTicking = true;
    requestAnimationFrame(() => {
      progressTicking = false;
      updateProgress();
    });
  };

  const scrollToBuy = (trigger) => {
    const purchase = document.getElementById('pdp-purchase');
    if (!purchase) return;
    purchase.scrollIntoView({ behavior:reducedMotion ? 'auto' : 'smooth', block:'start' });
    window.setTimeout(() => {
      const target = purchase.querySelector('[data-product-submit]:not([disabled]), select, input[name="quantity"]');
      target?.focus?.({ preventScroll:true });
    }, reducedMotion ? 0 : 500);
    publish('pdp_funnel_cta_clicked', {
      state: String(page?.dataset.state || funnel?.dataset.state || '').slice(0,40),
      product_handle: window.DOPAAnalytics?.context?.().product_handle || '',
      label: String(trigger?.textContent || '').trim().slice(0,80)
    });
  };

  document.addEventListener('click', (event) => {
    const mobileAdd = event.target.closest?.('[data-mobile-add]');
    if (mobileAdd) {
      event.preventDefault();
      event.stopPropagation();
      const form = document.querySelector('[data-product-section] .product-form');
      const submit = form?.querySelector('[data-product-submit]');
      const scrollOnly = mobileAdd.getAttribute('data-scroll-only') === 'true' || !form || !submit || submit.disabled;
      if (scrollOnly) {
        scrollToBuy(mobileAdd);
      } else {
        if (form.requestSubmit) form.requestSubmit(submit); else submit.click();
        publish('pdp_mobile_add_clicked', {
          product_handle: window.DOPAAnalytics?.context?.().product_handle || '',
          label: String(mobileAdd.textContent || '').trim().slice(0,80)
        });
      }
      return;
    }

    const buyLink = event.target.closest?.('[data-d59-scroll-buy]');
    if (buyLink) {
      event.preventDefault();
      scrollToBuy(buyLink);
    }

    const offer = event.target.closest?.('[data-d59-offer-card]');
    if (offer) {
      const action = event.target.closest('button') ? 'quick-add' : (event.target.closest('a') ? 'open-product' : 'card');
      publish('pdp_cross_sell_clicked', {
        action,
        offer_title: String(offer.querySelector('h3')?.textContent || '').trim().slice(0,100),
        source_product: window.DOPAAnalytics?.context?.().product_handle || ''
      });
    }
  }, true);

  document.addEventListener('toggle', (event) => {
    const detail = event.target;
    if (!(detail instanceof HTMLDetailsElement) || !detail.open || !detail.closest('[data-d59-faq]')) return;
    publish('pdp_faq_opened', {
      question: String(detail.querySelector('summary')?.textContent || '').trim().slice(0,120),
      product_handle: window.DOPAAnalytics?.context?.().product_handle || ''
    });
  }, true);

  document.addEventListener('change', (event) => {
    if (!event.target.matches?.('[data-variant-select], [data-variant-radio], input[name="quantity"]')) return;
    requestAnimationFrame(() => syncLabels(document));
  });

  document.addEventListener('dopa:cart-added', () => {
    window.setTimeout(() => syncLabels(document), 1450);
  });
  document.addEventListener('shopify:section:load', (event) => syncLabels(event.target || document));

  window.addEventListener('scroll', queueProgress, { passive:true });
  window.addEventListener('resize', queueProgress, { passive:true });
  document.addEventListener('DOMContentLoaded', () => {
    syncLabels(document);
    updateProgress();
    publish('professional_pdp_viewed', {
      state: String(page?.dataset.state || funnel?.dataset.state || '').slice(0,40),
      product_handle: window.DOPAAnalytics?.context?.().product_handle || '',
      funnel_version: 'V59'
    });
  }, { once:true });

  syncLabels(document);
  updateProgress();
})();
